import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "@/components/ui/select";

export enum SortSportEnum {
  EARLIEST_EVENT_DATE = "開催日が早い順",
  HIGHEST_PRIZE_AMOUNT = "賞金額が高い順",
  HIGHEST_ENTRY_FEE = "エントリー費用が高い順",
  LOWEST_ENTRY_FEE = "エントリー費用が安い順",
  NEWEST_TOURNAMENT = "新着順",
  ROUND_0001 = "11人制/中級者",
  ROUND_0002 = "5人制/初級者",
}

type SelectSortSportProps = {
  sortBy: SortSportEnum;
  setSortBy: (sortBy: SortSportEnum) => void;
};

export const SelectSortSport = ({ sortBy, setSortBy }: SelectSortSportProps) => {
  return (
    <Select value={sortBy} onValueChange={(value: string) => setSortBy(value as SortSportEnum)}>
      <SelectTrigger
        className="max-w-fit border-secondary rounded-lg text-[#0098EA] font-semibold ring-0 focus:ring-0 text-center"
        iconClassName="opacity-100 text-secondary w-5 h-5"
      >
        <p className="w-full text-center px-1 text-xs font-bold">{sortBy}</p>
      </SelectTrigger>

      <SelectContent className="rounded-lg">
        <SelectGroup>
          {Object.values(SortSportEnum).map((value) => (
            <SelectItem key={value} value={value}>
              {value}{" "}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
